import * as React from "react";
import { Block } from "baseui/block";
import { HeadingMedium } from "kanopi-components/typography";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TNoContentMessage = {
  message: string;
  maxWidth?: string;
  children?: React.ReactNode;
};

export const NoContentMessage = (props: TNoContentMessage) => {
  const { message, maxWidth = "150px", children } = props;
  const [css, theme] = useStyletron();

  return (
    <Block
      display="flex"
      flexDirection="column"
      alignItems="center"
      paddingTop="scale900"
      paddingBottom="scale400"
      width="100%"
      className={css({ textAlign: "center" })}
    >
      <HeadingMedium color={theme.colors.contentTertiary} maxWidth={maxWidth}>
        {message}
      </HeadingMedium>
      {children}
    </Block>
  );
};
